import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import DashboardLayoutWrapper from '../-module-components/layout'
import { SidebarProvider } from '@/components/ui/sidebar'
import { Loading } from '@/layouts/loading'
import { Level } from '@/gen/auth/common_pb'
import GlobalCommandMenu from '@/components/command-modal/globalCommandModal'

export const Route = createFileRoute('/(inventory)/branch/_layout')({
  component: () => (
    <SidebarProvider>
      <DashboardLayoutWrapper>
        <GlobalCommandMenu />
        <Outlet />
      </DashboardLayoutWrapper>
    </SidebarProvider>
  ),
  beforeLoad: async () => {
    const level = localStorage.getItem("level");
    if (level === Level.STOCK_POINT.toString()) {
        return redirect({
            to: "/overview",
        });
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
})
